<mat-card>
  <mat-card-actions class="buttons-container">
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="onAddNewRule()">
      <mat-icon>rule</mat-icon>
      Add Expression Rule
    </button>

    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="onAddNewChildBlock()">
      <mat-icon>rule_folder</mat-icon>
      Add Expression Block
    </button>

    @if (canBeRemoved) {
      <button
        mat-stroked-button
        color="warn"
        type="button"
        (click)="onRemoveBlock()">
        <mat-icon>delete_forever</mat-icon>
        Remove this Expression Block
      </button>
    }
  </mat-card-actions>
  <mat-card-content>
    <mat-form-field>
      <mat-label>Block Logic Operator</mat-label>
      <mat-select
        [value]="block.operator"
        (valueChange)="onOperatorChange($event)">
        @for (operator of expressionOperators; track operator) {
          <mat-option
            [value]="operator">
            {{ operator }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (block.rules) {
      <div>
        <h2>Expression Rules</h2>
        @for (rule of block.rules; track rule; let i = $index) {
          <gymfinder-expression
            [expressionRule]="rule"
            [studioTypes]="studioTypes"
            [activities]="activities"
            [services]="services"
            [equipmentsToBring]="equipmentsToBring"
            [gymInfos]="gymInfos"
            [gymTypes]="gymTypes"
            [gymEquipments]="gymEquipments"
            [networks]="networks"
            [geniusFeatures]="geniusFeatures"
            (expressionRuleChange)="onRuleChange($event, i)"
          (expressionRuleRemoved)="onRuleRemoved(i)"></gymfinder-expression>
        }
      </div>
    }

    <mat-divider></mat-divider>

    @if (block.blocks) {
      <div>
        <h2>Expression Blocks</h2>
        @for (block of block.blocks; track block; let i = $index) {
          <gymfinder-block
            [block]="block"
            [studioTypes]="studioTypes"
            [activities]="activities"
            [services]="services"
            [equipmentsToBring]="equipmentsToBring"
            [gymInfos]="gymInfos"
            [gymTypes]="gymTypes"
            [gymEquipments]="gymEquipments"
            [networks]="networks"
            [geniusFeatures]="geniusFeatures"
            [canBeRemoved]="true"
            (blockChange)="onChildBlockChange($event, i)"
          (blockRemoved)="onChildBlockRemoved(i)"></gymfinder-block>
        }
      </div>
    }
  </mat-card-content>
</mat-card>
